import axios from "axios";

export default {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    create(context, data) {
      return new Promise(resolve => {
        axios
          .post("v1/contacts", data)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            context.dispatch("app/flashError", null, {
              root: true
            });
            resolve(false);
          });
      });
    }
  },
  getters: {}
};
